var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09091 0C3.18135 0 0 3.18135 0 7.09091V16.9091C0 20.8186 3.18135 24 7.09091 24H16.9091C20.8186 24 24 20.8186 24 16.9091V7.09091C24 3.18135 20.8186 0 16.9091 0H7.09091ZM7.09091 1.09091H16.9091C20.229 1.09091 22.9091 3.77101 22.9091 7.09091V16.9091C22.9091 20.229 20.229 22.9091 16.9091 22.9091H7.09091C3.77101 22.9091 1.09091 20.229 1.09091 16.9091V7.09091C1.09091 3.77101 3.77101 1.09091 7.09091 1.09091ZM18.5455 4.36364C18.2561 4.36364 17.9787 4.47857 17.7741 4.68316C17.5695 4.88774 17.4545 5.16522 17.4545 5.45455C17.4545 5.74387 17.5695 6.02135 17.7741 6.22593C17.9787 6.43052 18.2561 6.54545 18.5455 6.54545C18.8348 6.54545 19.1123 6.43052 19.3168 6.22593C19.5214 6.02135 19.6364 5.74387 19.6364 5.45455C19.6364 5.16522 19.5214 4.88774 19.3168 4.68316C19.1123 4.47857 18.8348 4.36364 18.5455 4.36364ZM12 6C8.69275 6 6 8.69275 6 12C6 15.3072 8.69275 18 12 18C15.3072 18 18 15.3072 18 12C18 8.69275 15.3072 6 12 6ZM12 7.09091C14.7177 7.09091 16.9091 9.28232 16.9091 12C16.9091 14.7177 14.7177 16.9091 12 16.9091C9.28232 16.9091 7.09091 14.7177 7.09091 12C7.09091 9.28232 9.28232 7.09091 12 7.09091Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIc);
export default __webpack_public_path__ + "static/media/insta_ic.832740658577703e7696f4544bec325d.svg";
export { ForwardRef as ReactComponent };